import { Reveal } from "@/components/portfolio/motion";

const TOOLS = [
  "Claude",
  "Lovable",
  "Emergent",
  "Gamma",
  "Canva AI",
  "Notion",
  "Make",
  "Google Analytics",
];

const Item = ({ label }) => (
  <span className="flex items-center gap-8 sm:gap-12 shrink-0">
    <span className="font-display text-2xl sm:text-3xl font-semibold text-ink/80 whitespace-nowrap">
      {label}
    </span>
    <span className="w-2 h-2 rounded-full bg-accent/70 shrink-0" />
  </span>
);

export const Marquee = () => (
  <Reveal>
    <div
      data-testid="tools-marquee"
      className="marquee-track relative overflow-hidden py-10 sm:py-14 border-y border-line bg-surface/60"
    >
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 z-10 bg-gradient-to-r from-paper to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 z-10 bg-gradient-to-l from-paper to-transparent" />
      <div className="flex w-max animate-marquee gap-8 sm:gap-12">
        {[...TOOLS, ...TOOLS].map((t, i) => (
          <Item key={i} label={t} />
        ))}
      </div>
    </div>
  </Reveal>
);
